var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing---Web-Copy-6",
    transform: "translate(-792.000000, -283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-8",
    transform: "translate(792.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.456522,178.913043 C147.100571,178.913043 184.913043,141.100571 184.913043,94.4565217 C184.913043,47.8124728 147.100571,10 100.456522,10 C53.8124728,10 16,47.8124728 16,94.4565217 C16,105.979411 16,139.493903 16,195 L48.173913,178.913043 C73.0125928,178.913043 90.4401291,178.913043 100.456522,178.913043 Z",
    id: "Oval",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4795491,105.109825 L51.5,86.5004162 L51.5,86.5004162 C48.1666667,81.6690362 46.5,78.0023695 46.5,75.5004162 C46.5,39.5004162 75.9135361,23 97,23 C132,23 151.5,43.0004162 157,58.0004162 C162.5,73.0004162 159.558273,98.1205111 147.5,106.000416 C133.732318,114.997395 149.128405,133.673885 139,136.500416 C125.658142,140.223726 113.471536,151.889397 102.440183,171.49743 L102.440182,171.49743 C101.898586,172.460106 100.679133,172.80146 99.7164562,172.259864 C99.2477635,171.996181 98.9050083,171.554858 98.7655364,171.035484 C95.5651037,159.117513 91.4765915,150.77249 86.5,146.000416 C78.038405,137.886558 61.0474225,152.823096 55,139.000416 C52.6666667,133.667083 51.5,124.500416 51.5,111.500416 L41.8960132,106.469756 C41.4067819,106.213492 41.2179246,105.609149 41.4741886,105.119918 C41.4759562,105.116543 41.477743,105.113179 41.4795491,105.109825 Z",
    id: "Path-5",
    stroke: "#000000",
    strokeWidth: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.0841a31ff6ee3e706c4b90e4201942d6.svg";
export { ForwardRef as ReactComponent };